import React, { Component } from 'react';
import { Row, Col, Card, CardBody, FormGroup, Button, Label, Spinner, Modal, ModalHeader, ModalBody } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import Select from "react-select";
import SweetAlert from "react-bootstrap-sweetalert";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import { BaseUrl } from "../../helpers/Baseurl";
import { get } from '../../helpers/api_helper';
import { update } from 'lodash';

class ActivityDetail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activity_success_confirm: false,
            activity_alert_confirm: false,
            dynamic_title: "",
            dynamic_description: "",
            addActivityloading: false,
            editActivityloading: false,
            itinerary: this.props.data,
            ActivityLocationsGroup: this.props.location,
            activity_id: "",
            itineraryActivities: [],
            selectedActivityLocation: { label: "Select Location", value: null },
            selectedActivity: { label: "Select Activity", value: null },
            selectedActivityPricing: { label: "Select Activity Package", value: null },
            ActivitiesGroup: [],
            ActivityPricing: [],
            ActivityPricingTypeGroup: [],
            selected_activity: {}
        };

        toastr.options = {
            positionClass: "toast-top-right",
            closeButton: "false",
            progressBar: "true",
            showEasing: "swing",
            hideEasing: "linear",
            showMethod: "fadeIn",
            hideMethod: "fadeOut",
            showDuration: 300,
            hideDuration: 1000,
            timeOut: 5000,
            extendedTimeOut: 1000
        };

        this.clearStateData = this.clearStateData.bind(this);
        this.tog_addActivity = this.tog_addActivity.bind(this);
        this.handleActivityDelete = this.handleActivityDelete.bind(this);
        this.handleSaveActivity = this.handleSaveActivity.bind(this);
        this.handleEditActivitySubmit = this.handleEditActivitySubmit.bind(this);
        this.autoAddActivitiesFromPlaces = this.autoAddActivitiesFromPlaces.bind(this);
    }

    clearStateData() {
        this.setState({
            addActivityloading: false,
            editActivityloading: false,
            activity_id: "",
            selectedActivityLocation: { label: "Select Location", value: null },
            selectedActivity: { label: "Select Activity", value: null },
            selectedActivityPricing: { label: "Select Activity Package", value: null },
            ActivitiesGroup: [],
            ActivityPricing: [],
            ActivityPricingTypeGroup: []
        });
    }

    tog_addActivity() {
        this.clearStateData();
        this.setState(prevState => ({
            model_addActivity: !prevState.model_addActivity
        }));
        this.removeBodyCss();
    }

    tog_editActivity() {
        this.setState(prevState => ({
            model_editActivity: !prevState.model_editActivity
        }));
        this.removeBodyCss();
    }

    removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    componentDidCatch(error) {
        console.log(error);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            this.setState({ itinerary: this.props.data });
        }
        if (prevProps.location !== this.props.location) {
            this.setState({ ActivityLocationsGroup: this.props.location });
        }
    }

    async componentDidMount() {
        await this.loadItineraryActivities();
    }

    async loadItineraryActivities() {
        const { itinerary } = this.state;
        let url = `${BaseUrl}/api/itineraries/itinerary-activities/?itinerary__id=${itinerary.id}`;
        await get(url, { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.props.access}` } })
            .then(response => {
                this.setState({ itineraryActivities: response });
                let total = 0;
                let visited_days = [];
                let activities_id = "";
                for (let i = 0; i < response.length; i++) {
                    if (parseInt(response[i].margin_price) > 0 && !visited_days.includes(response[i].day)) {
                        visited_days.push(response[i].day);
                        total += parseInt(response[i].margin_price);
                    }
                    activities_id += response[i].activity.id + ",";
                }
                this.props.handleActivityTotal(total);
                this.clearStateData();
                this.loadPaymentDetail(activities_id);
            });
    }

    async loadActivityByPlacesData(place_id) {
        if (place_id) {
            let url = `${BaseUrl}/api/activities/activities/?place__id=${place_id}`;
            return await get(url, { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.props.access}` } })
                .then(response => {
                    let options = [];
                    response.results.forEach(activity => {
                        options.push({ label: activity.name, value: activity.id });
                    });
                    let ActivitiesGroup = [{ label: "Activities", options }];
                    this.setState({ ActivitiesGroup });
                    return response.results;
                });
        }
    }

    async loadPaymentDetail(id) {
        await get(`${BaseUrl}/api/activities/activity-bank-detail/?activity__id__in=${id}`, {
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.props.access}` }
        }).then(response => {
            this.setState({ bank_details: response.results });
        });
    }

    async loadActivityData(id) {
        await fetch(`${BaseUrl}/api/activities/activities/${id}/`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.props.access}` }
        })
            .then(res => res.json())
            .then(data => {
                let options = [];
                data.pricing.forEach(pricing => {
                    let label = `Distance ${pricing.distance} KM - Duration ${pricing.duration} Hours`;
                    options.push({ label, value: pricing.id });
                });
                let ActivityPricingTypeGroup = [{ label: "Pricing", options }];
                this.setState({
                    ActivityPricingTypeGroup,
                    ActivityPricing: data.pricing,
                    ActivitySeasons: data.seasons
                });
            });
    }

    is_Season() {
        const { ActivitySeasons, itinerary } = this.state;
        let on_season = false;
        let startDate = new Date(itinerary.start_date);
        let endDate = new Date(itinerary.end_date);
        for (let season of ActivitySeasons) {
            let seasonStartDate = new Date(`${season.start_month}-${season.start_date}-${startDate.getFullYear()}`);
            let seasonEndDate = new Date(`${season.end_month}-${season.end_date}-${season.end_month < season.start_month ? startDate.getFullYear() + 1 : startDate.getFullYear()}`);
            if ((startDate >= seasonStartDate && startDate <= seasonEndDate) || (endDate >= seasonStartDate && endDate <= seasonEndDate)) {
                on_season = true;
                break;
            }
        }
        return on_season;
    }

    async autoAddActivitiesFromPlaces() {
        const { itinerary, itineraryActivities } = this.state;
        const placeIds = itinerary.places.map(place => place.id);
        let addedCount = 0;

        for (const placeId of placeIds) {
            const activities = await this.loadActivityByPlacesData(placeId);
            if (activities && activities.length > 0) {
                for (const activity of activities) {
                    // Check if the activity is already in the itinerary
                    const isAlreadyAdded = itineraryActivities.some(existing => existing.activity.id === activity.id);
                    if (!isAlreadyAdded) {
                        await this.loadActivityData(activity.id);
                        const { ActivityPricing } = this.state;

                        const selectedPricing = ActivityPricing[0];
                        if (selectedPricing) {
                            this.setState({
                                selectedActivity: { label: activity.name, value: activity.id },
                                selectedActivityPricing: { label: `Distance ${selectedPricing.distance} KM - Duration ${selectedPricing.duration} Hours`, value: selectedPricing.id }
                            });

                            const defaultValues = {
                                persons: itinerary.pax.toString(),
                                day: Math.min(Math.ceil((placeIds.indexOf(placeId) + 1) / (placeIds.length / (itinerary.end_date.split('-')[2] - itinerary.start_date.split('-')[2] + 1))), 7).toString()
                            };
                            await this.handleSaveActivity(null, defaultValues);
                            addedCount++;
                        }
                    }
                }
            }
        }
        
        if (addedCount > 0) {
            toastr.success(`Added ${addedCount} new activities from itinerary ${itinerary.id}!`);
        } else {
            toastr.info(`All activities from itinerary ${itinerary.id} are already added.`);
        }
    }

    handleSelectLocationGroup = selectedActivityLocation => {
        this.setState({ selectedActivityLocation });
        this.loadActivityByPlacesData(selectedActivityLocation.value);
    }

    handleselectedActivity = selectedActivity => {
        this.loadActivityData(selectedActivity.value);
        this.setState({ selectedActivity, selectedActivityPricing: { label: "Select Activity Package", value: null } });
    }

    handleSelectedActivityPricing = selectedActivityPricing => {
        this.setState({ selectedActivityPricing });
    }

    handleActivityDelete(id) {
        fetch(`${BaseUrl}/api/itineraries/itinerary-activities/${id}/`, {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${this.props.access}` }
        }).then(res => {
            if (res.status >= 400) {
                console.log("Error deleting activity");
            } else {
                this.loadItineraryActivities();
                this.setState({
                    activity_id: "",
                    activity_success_confirm: true,
                    activity_alert_confirm: false,
                    dynamic_title: "Deleted!",
                    dynamic_description: "Activity has been deleted."
                });
            }
        });
    }

    handleActivityEdit(id) {
        const { itineraryActivities } = this.state;
        const selected_activity = itineraryActivities.find(activity => activity.id === id);
        if (selected_activity) {
            let label = `Distance ${selected_activity.pricing.distance} KM - Duration ${selected_activity.pricing.duration}`;
            this.setState({
                selected_activity,
                selectedActivityPricing: { label, value: selected_activity.pricing.id }
            });
            this.tog_editActivity();
            this.loadActivityData(selected_activity.activity.id);
        }
    }

    handleEditActivitySubmit(e, values) {
        const { ActivityPricing, selectedActivityPricing, selected_activity } = this.state;
        if (parseInt(values.persons) < 0) {
            toastr.error("Please Select Valid Person Count", "");
            return;
        }

        this.setState({ editActivityloading: true });
        let total_price = 0;
        let selected_price = ActivityPricing.find(pricing => pricing.id === selectedActivityPricing.value);
        let pricing = null;
        let persons = parseInt(values.persons);
        let on_season = this.is_Season();

        if (persons < 3) {
            pricing = on_season ? selected_price.group_pricing[0].on_season_price : selected_price.group_pricing[0].price;
        } else {
            let grp_price = selected_price.group_pricing;
            for (let j = 1; j < grp_price.length; j++) {
                if (grp_price[j].group.min_person <= persons && grp_price[j].group.max_person >= persons) {
                    pricing = on_season ? grp_price[j].on_season_price : grp_price[j].price;
                }
            }
            if (!pricing) {
                pricing = on_season ? grp_price.slice(-1)[0].on_season_price : grp_price.slice(-1)[0].price;
            }
        }

        total_price = parseInt(pricing) * persons;
        let data = {
            itinerary: selected_activity.itinerary,
            activity: selected_activity.activity.id,
            pricing: selected_price.id,
            person_count: persons,
            margin_price: total_price,
            day: values.day
        };

        fetch(`${BaseUrl}/api/itineraries/itinerary-activities/${selected_activity.id}/`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.props.access}` },
            body: JSON.stringify(data)
        }).then(res => {
            if (res.status >= 400) {
                res.json().then(data => {
                    toastr.error("Something Went Wrong", "");
                    this.setState({ editActivityloading: false });
                });
            } else {
                res.json().then(data => {
                    toastr.success(`${data.activity.name} Updated Successfully`, "");
                    this.setState({ model_editActivity: false, editActivityloading: false });
                    this.loadItineraryActivities();
                });
            }
        });
    }

    handleSaveActivity(e, values) {
        const { itinerary, ActivityPricing, selectedActivity, selectedActivityPricing } = this.state;
        if (!selectedActivityPricing.value) {
            toastr.error("Please Select Package", "");
            return;
        }

        this.setState({ addActivityloading: true });
        let total_price = 0;
        let selected_price = ActivityPricing.find(pricing => pricing.id === selectedActivityPricing.value);
        let pricing = null;
        let persons = parseInt(values.persons);
        let on_season = this.is_Season();

        if (persons < 3) {
            pricing = on_season ? selected_price.group_pricing[0].on_season_price : selected_price.group_pricing[0].price;
        } else {
            let grp_price = selected_price.group_pricing;
            for (let j = 1; j < grp_price.length; j++) {
                if (grp_price[j].group.min_person <= persons && grp_price[j].group.max_person >= persons) {
                    pricing = on_season ? grp_price[j].on_season_price : grp_price[j].price;
                }
            }
            if (!pricing) {
                pricing = on_season ? grp_price.slice(-1)[0].on_season_price : grp_price.slice(-1)[0].price;
            }
        }

        total_price = pricing ? parseInt(pricing) * persons : 0;
        let data = {
            itinerary: itinerary.id,
            activity: selectedActivity.value,
            pricing: selected_price.id,
            person_count: persons,
            margin_price: total_price,
            day: values.day
        };

        fetch(`${BaseUrl}/api/itineraries/itinerary-activities/`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.props.access}` },
            body: JSON.stringify(data)
        }).then(res => {
            if (res.status >= 400) {
                res.json().then(data => {
                    toastr.error("Something Went Wrong", "");
                    this.setState({ addActivityloading: false });
                });
            } else {
                res.json().then(data => {
                    toastr.success(`${data.activity.name} Added Successfully`, "");
                    this.setState({ model_addActivity: false, addActivityloading: false });
                    this.loadItineraryActivities();
                });
            }
        });
    }

    render() {
        const { itineraryActivities, selected_activity } = this.state;
        const activityColumns = [
            { dataField: "id", text: "id", hidden: true },
            {
                dataField: "activity",
                text: "Name",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (
                    <Link to={`/activity/${row.activity.id}`} target="_blank" className="text-dark me-2">{row.activity.name}</Link>
                )
            },
            {
                dataField: "location",
                text: "Location",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (row.activity.place ? row.activity.place.name : "")
            },
            {
                dataField: "activity_type",
                text: "Activity Type",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (row.activity.activity_type)
            },
            {
                dataField: "person_count",
                text: "NO. of Persons",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (row.person_count),
                align: 'center'
            },
            {
                dataField: "pricing",
                text: "Selected Package",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (`Distance ${row.pricing.distance} KM - Duration ${row.pricing.duration} Hours`)
            },
            {
                dataField: "margin_price",
                text: "Total Price",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => ("₹ " + row.margin_price),
                align: 'right'
            },
            {
                dataField: "menu",
                isDummyField: true,
                text: "Action",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c', width: '10%' },
                formatter: (cellContent, row) => (
                    <div style={{ textAlign: "center" }}>
                        <Link to="#" onClick={() => this.handleActivityEdit(row.id)} className="text-secondary me-2"><i className="mdi mdi-lead-pencil font-size-18"></i></Link>
                        <Link to="#" onClick={() => this.setState({ activity_id: row.id, activity_alert_confirm: true })} className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
                    </div>
                )
            }
        ];

        const activityColumnsnotEdit = [
            { dataField: "id", text: "id", hidden: true, sort: true },
            {
                dataField: "activity",
                text: "Name",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (
                    <Link to={`/activity/${row.activity.id}`} target="_blank" className="text-dark me-2">{row.activity.name}</Link>
                )
            },
            {
                dataField: "location",
                text: "Location",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (row.activity.place.name)
            },
            {
                dataField: "activity_type",
                text: "Activity Type",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (row.activity.activity_type)
            },
            {
                dataField: "person_count",
                text: "NO. of Persons",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (row.person_count),
                align: 'center'
            },
            {
                dataField: "pricing",
                text: "Selected Package",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => (`Distance ${row.pricing.distance} KM - Duration ${row.pricing.duration} Hours`)
            },
            {
                dataField: "margin_price",
                text: "Total Price",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => ("₹ " + row.margin_price),
                align: 'right'
            }
        ];

        return (
            <React.Fragment key={"activity-Detail"}>
                <Row>
                    <Col xs={12}>
                        <Card>
                            {!["tour completed"].includes(this.state.itinerary.status) && this.props.user.role !== 1 ?
                                <CardBody>
                                    <div className="table-responsive">
                                        <BootstrapTable
                                            keyField="id"
                                            data={itineraryActivities}
                                            columns={activityColumns}
                                            striped={true}
                                            cellEdit={cellEditFactory({ mode: 'click', blurToSave: true })}
                                        />
                                    </div>
                                    <div style={{ textAlign: "center" }}>
                                        <Button color="secondary" outline className="waves-effect me-1 mb-3" onClick={this.tog_addActivity}>
                                            Add New Activity
                                        </Button>
                                        <Button color="secondary" outline className="waves-effect me-1 mb-3" onClick={this.autoAddActivitiesFromPlaces}>
                                            Auto Add Activities
                                        </Button>
                                    </div>
                                </CardBody>
                                :
                                <CardBody>
                                    <div className="table-responsive">
                                        <BootstrapTable
                                            keyField="id"
                                            data={itineraryActivities}
                                            columns={activityColumnsnotEdit}
                                        />
                                    </div>
                                </CardBody>
                            }
                        </Card>
                    </Col>
                </Row>

                <Col sm={6} md={4} xl={3} className="mt-4">
                    <Modal isOpen={this.state.model_addActivity} toggle={this.tog_addActivity} centered={true}>
                        <ModalHeader toggle={this.tog_addActivity}>Add Activity</ModalHeader>
                        <ModalBody>
                            <AvForm className="needs-validation" onValidSubmit={this.handleSaveActivity}>
                                <Row>
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label">Location</Label>
                                            <Select
                                                value={this.state.selectedActivityLocation}
                                                onChange={this.handleSelectLocationGroup}
                                                options={this.state.ActivityLocationsGroup}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label" htmlFor="persons">No of Pax</Label>
                                            <AvField
                                                name="persons"
                                                placeholder="No of Pax"
                                                type="number"
                                                className="form-control"
                                                errorMessage="Enter Only Number"
                                                validate={{
                                                    required: { value: true },
                                                    pattern: { value: "^[0-9]+$", errorMessage: "Only Numbers" }
                                                }}
                                                id="persons"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12">
                                        <div className="mb-3">
                                            <Label className="form-label">Activities</Label>
                                            <Select
                                                value={this.state.selectedActivity}
                                                onChange={this.handleselectedActivity}
                                                options={this.state.ActivitiesGroup}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12">
                                        <div className="mb-3">
                                            <Label className="form-label">Package</Label>
                                            <Select
                                                value={this.state.selectedActivityPricing}
                                                onChange={this.handleSelectedActivityPricing}
                                                options={this.state.ActivityPricingTypeGroup}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label" htmlFor="activity_day">Day</Label>
                                            <AvField
                                                name="day"
                                                placeholder="Activity Day"
                                                type="number"
                                                className="form-control"
                                                errorMessage="Enter Only Number"
                                                validate={{
                                                    required: { value: true },
                                                    pattern: { value: "^[0-9]+$", errorMessage: "Only Numbers" }
                                                }}
                                                id="activity_day"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <FormGroup className="mb-0">
                                    {this.state.addActivityloading ? (
                                        <Spinner className="me-2 mt-2" color="primary" />
                                    ) : (
                                        <Button type="submit" color="primary" className="me-1">Submit</Button>
                                    )}
                                </FormGroup>
                            </AvForm>
                        </ModalBody>
                    </Modal>
                </Col>

                <Col sm={6} md={4} xl={3} className="mt-4">
                    <Modal isOpen={this.state.model_editActivity} toggle={this.tog_editActivity} centered={true}>
                        <ModalHeader toggle={() => this.tog_editActivity()}>
                            Edit {selected_activity.activity ? selected_activity.activity.name : ""} Activity
                        </ModalHeader>
                        <ModalBody>
                            <AvForm className="needs-validation" onValidSubmit={this.handleEditActivitySubmit}>
                                <Row>
                                    <Col md="12">
                                        <div className="mb-3">
                                            <Label className="form-label">Package</Label>
                                            <Select
                                                value={this.state.selectedActivityPricing}
                                                onChange={this.handleSelectedActivityPricing}
                                                options={this.state.ActivityPricingTypeGroup}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label" htmlFor="persons">No of Paxs</Label>
                                            <AvField
                                                name="persons"
                                                value={selected_activity.person_count}
                                                type="number"
                                                className="form-control"
                                                errorMessage="Enter Only Number"
                                                validate={{
                                                    required: { value: true },
                                                    pattern: { value: "^[0-9]+$", errorMessage: "Only Numbers" }
                                                }}
                                                id="persons"
                                            />
                                        </div>
                                    </Col>
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label" htmlFor="edit_activity_day">Day</Label>
                                            <AvField
                                                name="day"
                                                placeholder="Activity Day"
                                                value={selected_activity.day}
                                                type="number"
                                                className="form-control"
                                                errorMessage="Enter Only Number"
                                                validate={{
                                                    required: { value: true },
                                                    pattern: { value: "^[0-9]+$", errorMessage: "Only Numbers" }
                                                }}
                                                id="edit_activity_day"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <FormGroup className="mb-0">
                                    {this.state.editActivityloading ? (
                                        <Spinner className="me-2 mt-2" color="primary" />
                                    ) : (
                                        <Button type="submit" color="primary" className="me-1">Update</Button>
                                    )}
                                </FormGroup>
                            </AvForm>
                        </ModalBody>
                    </Modal>
                </Col>

                {this.state.activity_alert_confirm && (
                    <SweetAlert
                        title="Are you sure?"
                        warning
                        showCancel
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="danger"
                        onConfirm={() => this.handleActivityDelete(this.state.activity_id)}
                        onCancel={() => this.setState({ activity_alert_confirm: false, activity_id: "" })}
                    >
                        You won't be able to revert this!
                    </SweetAlert>
                )}

                {this.state.activity_success_confirm && (
                    <SweetAlert
                        success
                        title={this.state.dynamic_title}
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="danger"
                        onConfirm={() => this.setState({ activity_success_confirm: false, activity_alert_confirm: false })}
                    >
                        {this.state.dynamic_description}
                    </SweetAlert>
                )}
            </React.Fragment>
        );
    }
}

export default ActivityDetail;